export default __webpack_public_path__ + "static/media/background-5.1cb1a0b9.jpg";